/* Emițătorul de evenimente pentru GRILELE de produse (colecții, pagina de căutare)
 * și pentru linkurile către produse din descrierile bogate (PDP).
 *
 * SURSA UNICĂ e acest fișier. Se copiază identic ca `assets/am-list-tracking.js`
 * în tema DEV și se include din `theme.liquid`, lângă `am-reco-tracking.js`.
 *
 * E un emițător SEPARAT de cel al recomandărilor, deliberat: acela are selectori
 * verificați pe două blocuri (PDP + coș), o funcție de sursă cu fallback pe coș
 * și un contract deja în producție. Un listener generic pe „toate cardurile" ar
 * fi dublat evenimentele lui (Codex, 12.09.2026). Aici cardurile se iau DOAR din
 * grila paginii, niciodată din `.product-recommendations`.
 *
 * Publică două evenimente prin `Shopify.analytics.publish`:
 *   lista_afisat — carduri VIZIBILE ≥ prag timp de ~1 s, o dată per card per
 *                  încărcare, trimise în loturi de max 20 (limita proxy-ului)
 *   lista_click  — click pe linkul către produs al unui card, cu poziția lui
 *
 * DE CE PER CARD, NU PER GRILĂ. `am-typesense-filters.js` aduce TOATE paginile
 * colecției în DOM la încărcare (măsurat 12.09: 413 carduri pe `boxe-pasive`,
 * 48 în HTML) și filtrează prin `display:none`. O impresie „pe grilă" ar raporta
 * 413 când clientul a văzut 4. Poziția e indexul printre cardurile vizibile, în
 * ordinea DOM-ului — care e ordinea afișată (sortarea reîncarcă pagina, iar
 * reordonarea Typesense mută nodurile).
 */
(function () {
  'use strict';

  var meta = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page) || {};
  var SURSA, LISTA_ID, LISTA_NUME;

  /* `item_list_id` = `collection:<id numeric>`, nu handle-ul: handle-ul se schimbă la
   * redenumire, id-ul nu. Numele e titlul colecției (același pe care îl pune deja
   * Simprosys în `item_list_name`, ca rapoartele să nu se despice). */
  if (meta.pageType === 'collection' && meta.resourceId) {
    SURSA = 'colectie';
    LISTA_ID = 'collection:' + meta.resourceId;
    var h1 = document.querySelector('h1');
    LISTA_NUME = ((h1 && h1.textContent) || document.title || LISTA_ID).replace(/\s+/g, ' ').trim().slice(0, 60);
  } else if (meta.pageType === 'searchresults' || meta.pageType === 'search') {
    /* `searchresults` e valoarea REALĂ pe `/search` (măsurat 12.09.2026 în headless;
     * `search` era o presupunere a mea, iar emițătorul ieșea tăcut din funcție).
     * Păstrez ambele: Shopify a folosit `search` în alte teme, iar o valoare în plus
     * nu costă nimic. */
    SURSA = 'cautare';
    LISTA_ID = 'search_results';
    LISTA_NUME = 'Rezultate căutare';
  } else if (meta.pageType !== 'product') {
    /* Alte pagini n-au nici grilă, nici descriere bogată — dar AU dropdownul de
     * căutare, care stă în header pe toate paginile. Din 15.09.2026 nu mai ieșim
     * din fișier aici: sărim doar peste grilă și descriere, iar blocul de dropdown
     * de la final rulează oriunde. `SURSA` rămâne nedefinită, deci `grila()`
     * întoarce null și partea de grilă se auto-dezactivează. */
    SURSA = null;
  }
  /* Pe PDP nu există grilă: SURSA rămâne nedefinită, iar partea de impresii/click
   * pe grilă se auto-dezactivează (`grila()` întoarce null). Ce rulează acolo e
   * doar blocul de la finalul fișierului, pentru descrierea bogată. */

  /* Grila paginii, ALEASĂ EXPLICIT — nu „primul `.l4cl`": dropdown-ul de căutare
   * din header vine înaintea conținutului în DOM, iar blocul de recomandări din
   * coș e tot `ul.l4cl.upsell`. Măsurat 12.09: colecția e `ul#collection.l4cl`,
   * rezultatele native `div.results > ul.l4cl`. */
  function grila() {
    if (!SURSA) return null;   // PDP: nicio grilă de listă
    var g = document.querySelector('ul#collection.l4cl') ||
            document.querySelector('.results > ul.l4cl') ||
            document.querySelector('main ul.l4cl:not(.upsell)');
    if (!g || g.classList.contains('upsell') || g.closest('.product-recommendations')) return null;
    return g;
  }

  var SEL_CARD = 'li.product-card[data-product-id]';
  var SEL_LINK = 'a[href*="/products/"]';

  /* ── Testul A/B listă vs grilă (docs/superpowers/plans/2026-10-21-colectii-test-lista-grila.md) ──
   * Brațul vine din `window.amVizualizareBrat` ('a' | 'b' | ''), pus în <head> de
   * snippets/am-vizualizare-exp.liquid. Orice altă valoare = testul e OPRIT: niciun câmp, niciun context.
   *
   * 1. `lista_afisat` / `lista_click` din listele `collection:*` (și `search_results`, doar cât
   *    CAUTARE_IN_TEST) poartă `vizualizare` + `viewport` ca PERECHE — pixelul nu trimite unul singur,
   *    iar proxy-ul respinge unul singur cu `PayloadInvalid`. Dropdown-ul de căutare, recomandările și
   *    descrierea bogată nu trec pe aici niciodată.
   * 2. La clicul pe o CALE ELIGIBILĂ dintr-un card al grilei principale se scrie
   *    `sessionStorage['am_viz_ctx_<id>']`, pe care pixelul îl consumă la `product_added_to_cart`
   *    (`am_vizualizare_atc`). Fără context valid = nicio adăugare „din listă".
   *
   * CAUTARE_IN_TEST: Task 0 a confirmat `ul.l4cl.am-premium` pe /search; dacă tema DEV o pierde,
   * se pune `false` (și garda din am-collection-premium.js) și căutarea iese din tot lanțul. */
  var CAUTARE_IN_TEST = true;
  var PRAG_VIZUALIZARE_PX = 1000;   // același cu matchMedia din am-collection-premium.js
  var PREFIX_CTX_VIZ = 'am_viz_ctx_';
  /* Căile eligibile (markup: snippets/am-product-card-list.liquid): orice link spre PDP
   * (poză `a.am-card__media-link`, titlu `h3.am-card__title a`, `a.am-card__rating`, „Vezi opțiuni"
   * `a.am-card__cta--secondary`), butonul de submit al formularului `/cart/add` al cardului și
   * declanșatorul quickshop `[data-quickshop]`. NU intră: „Compară" (`label.am-compara-chk`), wishlist,
   * „Mai multe detalii", câmpurile cantității. */
  var SEL_CONTEXT_VIZ = 'a[href*="/products/"], form[action*="/cart/add"] [type="submit"], [data-quickshop]';
  /* Singurul link spre /products/ care NU e „deschide produsul acesta": cel de resigilat duce la ALT
   * produs (adăugarea lui n-ar corespunde cheii cardului). Culorile, „+N culori" și valorile de
   * opțiune duc tot la ACELAȘI produs (variantă aleasă; pixelul potrivește pe id-ul produsului),
   * deci contează: cardul → PDP → adăugare prin ele face parte din metrică. */
  var SEL_FARA_CONTEXT_VIZ = '.am-card__openbox-link';

  function bratVizualizare() {
    var b = window.amVizualizareBrat;
    return b === 'a' || b === 'b' ? b : '';
  }
  /* Viewportul e fixat O DATĂ pe încărcare de snippetul am-vizualizare-exp (`window.amVizualizareViewport`),
   * ca expunerea, impresiile, clicurile și contextul de coș să poarte aceeași valoare chiar dacă fereastra
   * trece de 1000 px mai târziu. Fără valoare validă (snippet vechi/lipsă): calculul de la fiecare eveniment. */
  function viewportVizualizare() {
    var fixat = window.amVizualizareViewport;
    if (fixat === 'gt1000' || fixat === 'le1000') return fixat;
    var mic;
    try { mic = window.matchMedia('(max-width: ' + PRAG_VIZUALIZARE_PX + 'px)').matches; }
    catch (e) { mic = window.innerWidth <= PRAG_VIZUALIZARE_PX; }
    return mic ? 'le1000' : 'gt1000';
  }
  /* Lista paginii intră în test? `LISTA_ID` e definit doar pe colecții și pe /search. */
  function listaInTest() {
    if (!SURSA || !LISTA_ID) return false;
    if (LISTA_ID.indexOf('collection:') === 0) return true;
    return LISTA_ID === 'search_results' && CAUTARE_IN_TEST === true;
  }
  /* Adaugă PERECHEA de câmpuri pe un eveniment al listei principale; fără braț valid sau în afara
   * listelor din test, evenimentul rămâne exact ca până acum. */
  function cuVizualizare(d) {
    var brat = bratVizualizare();
    if (!brat || !listaInTest()) return d;
    d.vizualizare = brat;
    d.viewport = viewportVizualizare();
    return d;
  }
  /* Același regim ca predarea căutării și contextul recomandărilor: storage doar cu acord analitic
   * CONFIRMAT (fail-closed) și șters la retragerea acordului. */
  function stergeContexteVizualizare() {
    try {
      var chei = [];
      for (var i = 0; i < sessionStorage.length; i++) {
        var k = sessionStorage.key(i);
        if (k && k.indexOf(PREFIX_CTX_VIZ) === 0) chei.push(k);
      }
      for (var j = 0; j < chei.length; j++) sessionStorage.removeItem(chei[j]);
    } catch (e) { /* storage indisponibil: nimic de șters */ }
  }
  function scrieContextVizualizare(id) {
    var brat = bratVizualizare();
    if (!brat || !listaInTest() || !permisAnalytics()) return;
    try {
      sessionStorage.setItem(PREFIX_CTX_VIZ + id, JSON.stringify({
        produs: id, brat: brat, viewport: viewportVizualizare(), la: Date.now()
      }));
    } catch (e) { /* storage blocat/plin: pierdem măsurarea adăugării, nu clicul */ }
  }
  var PRAG_DESKTOP = 0.5;
  var PRAG_MOBIL = 0.25;
  var DURATA_MS = 1000;
  var LOT_MAX = 20;          // MAX_ITEMS în worker/src/ga4-mp-proxy.ts
  var LOT_ASTEPTARE_MS = 400; // adună cardurile care devin vizibile împreună

  function idCard(li) {
    var id = li.getAttribute('data-product-id');
    return id && /^\d+$/.test(id) ? id : null;
  }
  /* `data-ts-hidden` = filtrat de Typesense. Sertarul coșului / panoul de filtre
   * acoperă grila fără s-o ascundă: geometric cardurile rămân „vizibile", dar
   * clientul nu le vede. Semnalat de Codex (12.09.2026); tema marchează starea
   * deschisă pe `<html>` (`f8fl-open` pentru filtre, `m6pn-open` pentru panouri). */
  function panouDeschis() {
    var c = document.documentElement.className || '';
    return /(^|\s)(f8fl-open|m6pn-open)(\s|$)/.test(c);
  }
  function vizibil(li) {
    return li.offsetParent !== null && !li.hasAttribute('data-ts-hidden') && !panouDeschis();
  }
  function carduriVizibile(g) {
    return [].filter.call(g.querySelectorAll(':scope > ' + SEL_CARD), vizibil);
  }
  function pozitia(li) {
    var g = li.parentElement;
    return g ? carduriVizibile(g).indexOf(li) : -1;
  }
  function prag() { return window.innerWidth < 768 ? PRAG_MOBIL : PRAG_DESKTOP; }

  function publica(nume, date) {
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      Shopify.analytics.publish('audio_monkey:' + nume, date);
    }
  }

  /* ── Jurnalul căutărilor (docs/superpowers/plans/2026-09-29-jurnal-cautari-ga4.md) ──────────
   * O ÎNCERCARE de căutare (`cautare_id`) = o căutare angajată. Afișările și clicurile din căutare
   * poartă doar id-ul; termenul pleacă O SINGURĂ DATĂ, pe `audio_monkey:cautare`, filtrat aici doar
   * de grosier (e-mail, ≥ 7 cifre, lungime). Bariera spre GA4 e vocabularul catalogului, verificat
   * de Worker. Tot ce e în storage cere acord confirmat.
   *
   * 13.10 (audit date RO §C3): până acum emițătorul cerea ca fiecare cuvânt să apară în TEXTUL
   * CARDURILOR afișate și nu trimitea termen deloc la zero rezultate. Rezultat măsurat: 709/1.513
   * căutări RO fără termen (46,9%), toate cele 42 fără rezultat. Cardurile nu sunt catalogul:
   * pe /search titlul e afișat FĂRĂ brand („TX-RZ50 Receiver AV…" pentru „onkyo"), iar Typesense
   * potrivește și pe subtitlu, tip, cod de model despărțit („lp 120") sau cu toleranță la greșeli,
   * deci 85 din 139 de căutări /search suprimate (recuperate din evenimentul nativ `search`) ar fi
   * trecut de vocabularul Workerului. Verificarea pe carduri AVEA totuși un efect protector: două
   * prenume care sunt, fiecare, cuvinte de catalog („ana maria") nu se regăseau pe carduri. Acel
   * efect s-a mutat în Worker, explicit și pe tot catalogul: mai multe cuvinte trec doar dacă un
   * același PRODUS le conține pe toate (co-ocurență, review Codex 13.10). Termenul brut pleacă
   * doar spre Workerul nostru (proxy-ul nu-l loghează); ce ajunge la GA4 decide Workerul. */
  var CHEIE_PREDARE = 'am_cautare_predare';
  var PREDARE_TTL_MS = 2 * 60 * 1000;

  function apiConsimtamant() {
    var cp = window.Shopify && Shopify.customerPrivacy;
    return !!(cp && typeof cp.analyticsProcessingAllowed === 'function');
  }
  function permisAnalytics() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === true);
    } catch (e) { return false; }
  }

  function idNou() {
    var a = '';
    try {
      var b = new Uint8Array(8);
      window.crypto.getRandomValues(b);
      for (var i = 0; i < b.length; i++) a += (b[i] % 36).toString(36);
    } catch (e) {
      a = (Math.random().toString(36) + Math.random().toString(36)).replace(/[^a-z0-9]/g, '');
    }
    return (a + Date.now().toString(36)).slice(0, 12);
  }

  /* Aceeași normalizare ca în Worker (vocabular-cautare.ts): NFKC, litere mici, mărcile diacritice
   * scoase, cuvinte = litere/cifre Unicode. Un browser fără `\p{…}` nu trimite termen deloc. */
  function cuvinte(text) {
    try {
      return String(text).normalize('NFKC').toLowerCase().normalize('NFD')
        .replace(/\p{M}+/gu, '').split(/[^\p{L}\p{N}]+/u).filter(function (c) { return c.length > 0; });
    } catch (e) { return null; }
  }
  function cheieTermen(t) {
    var c = cuvinte(t);
    return c && c.length ? c.join(' ') : '';
  }

  /* Termenul de trimis (normalizat), sau null: @ / ≥ 7 cifre (după NFKC) / lungime. Vocabularul
   * catalogului îl verifică Workerul (worker/src/vocabular-cautare.ts). */
  function termenValidat(brut) {
    if (typeof brut !== 'string') return null;
    var nfkc;
    try { nfkc = brut.normalize('NFKC'); } catch (e) { return null; }
    if (nfkc.indexOf('@') !== -1) return null;
    var cifre;
    try { cifre = (nfkc.match(/\p{Nd}/gu) || []).length; } catch (e) { return null; }
    if (cifre >= 7) return null;
    var tok = cuvinte(nfkc);
    if (!tok || !tok.length) return null;
    var termen = tok.join(' ');
    if (termen.length < 2 || termen.length > 60) return null;
    return termen;
  }

  function scriePredare(p) {
    if (!permisAnalytics()) return;
    try { sessionStorage.setItem(CHEIE_PREDARE, JSON.stringify({ id: p.id, cheie: p.cheie, angajata: !!p.angajata, la: Date.now() })); }
    catch (e) { /* storage blocat: continuarea se pierde, pagina nu */ }
  }
  /* Citește ȘI șterge; valabilă doar pentru același termen normalizat și în 2 minute. */
  function citestePredare(cheie) {
    try {
      var raw = sessionStorage.getItem(CHEIE_PREDARE);
      sessionStorage.removeItem(CHEIE_PREDARE);
      var p = raw && JSON.parse(raw);
      if (!p || p.cheie !== cheie || !/^[a-z0-9]{8,16}$/.test(String(p.id)) ||
          typeof p.la !== 'number' || Date.now() - p.la > PREDARE_TTL_MS) return null;
      return { id: String(p.id), angajata: !!p.angajata };
    } catch (e) { return null; }
  }
  /* Retragerea acordului șterge predarea (plan §3). */
  try {
    document.addEventListener('visitorConsentCollected', function () {
      if (!permisAnalytics()) {
        try { sessionStorage.removeItem(CHEIE_PREDARE); } catch (e) { /* idem */ }
        stergeContexteVizualizare();
      }
      /* Acord dat oricând după încărcare (și după ce reîncercările au expirat): pagina /search
         își pornește încercarea acum (review Codex 29.09). Funcția e idempotentă. */
      else if (typeof pornestePaginaCautare === 'function') pornestePaginaCautare();
    });
  } catch (e) { /* idem */ }

  function publicaCautare(inc, suprafata, motiv, stare, rezultate, termen) {
    var d = { cautare_id: inc.id, suprafata: suprafata, motiv: motiv, stare: stare, rezultate: rezultate };
    if (termen) d.termen = termen;
    publica('cautare', d);
  }

  /* `cautare_id` doar pe listele de căutare și doar dacă încercarea există (acord confirmat). */
  function cuId(d, inc) {
    if (inc && inc.id) d.cautare_id = inc.id;
    return d;
  }

  /* ── Pagina /search: încercarea ei ───────────────────────────────────────
   * Id-ul se leagă de INTRAREA din istoric (`history.state`), nu de termen: reîncărcarea și
   * „înapoi" regăsesc exact încercarea lor. Paginarea și sortarea (navigări noi) primesc aceeași
   * încercare, deja angajată, prin predare. Fără stare și fără predare = încercare nouă. */
  var paginaCautare = null;
  /* API-ul de acord (încărcat de am-reco-tracking.js) poate apărea DUPĂ DOMContentLoaded — pe DEV,
   * 29.09, lipsea la pornire. Cât LIPSEȘTE API-ul reîncercăm la 1 s, de cel mult 10 ori; un REFUZ
   * nu se reîncearcă — acordul dat mai târziu pornește pagina prin `visitorConsentCollected`. */
  var incercariPagina = 0;
  function pornestePaginaCautare() {
    if (SURSA !== 'cautare' || paginaCautare) return;
    if (!permisAnalytics()) {
      if (!apiConsimtamant() && ++incercariPagina <= 10) setTimeout(pornestePaginaCautare, 1000);
      return;
    }
    var q = '';
    try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) { return; }
    var cheie = cheieTermen(q);
    if (!cheie) return;
    var st = null;
    try { st = history.state && history.state.amCautare; } catch (e) { st = null; }
    var inc = (st && st.cheie === cheie && /^[a-z0-9]{8,16}$/.test(String(st.id)))
      ? { id: String(st.id), angajata: !!st.angajata }
      : (citestePredare(cheie) || { id: idNou(), angajata: false });
    inc.cheie = cheie;
    paginaCautare = inc;
    salveazaInIstoric(inc);
    if (!inc.angajata) {
      var g = grila();
      var carduri = g ? g.querySelectorAll(':scope > ' + SEL_CARD) : [];
      var n = Math.min(carduri.length, 250);
      var zero = !n && !!document.querySelector('.results');
      if (!n && !zero) return;   // grilă neidentificată: nu inventăm o stare
      publicaCautare(inc, 'pagina', 'pagina', n ? 'rezultate' : 'zero', n, termenValidat(q));
      inc.angajata = true;
      salveazaInIstoric(inc);
    }
  }
  /* Continuarea DOAR prin paginare și sortare (review Codex 29.09): un `pagehide` general scria
   * predarea și la clicul pe un produs, iar o căutare nouă cu același termen în 2 minute moștenea
   * încercarea veche. Paginarea = link către /search cu același termen; sortarea = `select#sort_by`. */
  function continuaPagina() {
    if (paginaCautare) scriePredare({ id: paginaCautare.id, cheie: paginaCautare.cheie, angajata: true });
  }
  document.addEventListener('click', function (ev) {
    if (!paginaCautare || !ev.target || !ev.target.closest) return;
    var a = ev.target.closest('a[href]');
    if (!a) return;
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      if (/\/search\/?$/.test(u.pathname) && cheieTermen(u.searchParams.get('q') || '') === paginaCautare.cheie) continuaPagina();
    } catch (e) { /* href invalid: nimic */ }
  }, true);
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (paginaCautare && t && t.getAttribute && t.getAttribute('name') === 'sort_by') continuaPagina();
  }, true);
  function salveazaInIstoric(inc) {
    try {
      var s0 = history.state && typeof history.state === 'object' ? history.state : {};
      var s1 = {};
      for (var k in s0) if (Object.prototype.hasOwnProperty.call(s0, k)) s1[k] = s0[k];
      s1.amCautare = { id: inc.id, cheie: inc.cheie, angajata: !!inc.angajata };
      history.replaceState(s1, '');
    } catch (e) { /* istoric indisponibil: reîncărcarea va număra o încercare nouă */ }
  }

  /* ── Impresia ──────────────────────────────────────────────────────────── */

  var vazute = {};   // id → true, o dată per card per încărcare
  var lot = [];
  var lotTimer = null;

  function trimiteLot() {
    lotTimer = null;
    while (lot.length) {
      var bucata = lot.splice(0, LOT_MAX);
      publica('lista_afisat', cuVizualizare(cuId({ sursa: SURSA, lista_id: LISTA_ID, lista_nume: LISTA_NUME, produse: bucata }, paginaCautare)));
    }
  }
  /* Lotul așteaptă 400 ms; un click imediat după ce cardul devine vizibil ar
   * naviga înainte de trimitere și impresia s-ar pierde. `pagehide` prinde și
   * navigarea, și închiderea filei (`visibilitychange` singur ratează bfcache). */
  function trimiteAcum() { clearTimeout(lotTimer); if (lot.length) trimiteLot(); }
  window.addEventListener('pagehide', trimiteAcum);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') trimiteAcum();
  });

  function inregistreaza(li) {
    var id = idCard(li);
    if (!id || vazute[id]) return;
    var poz = pozitia(li);
    if (poz < 0) return;   // a dispărut între timp (filtrare)
    vazute[id] = true;
    lot.push({ id: id, pozitie: poz });
    clearTimeout(lotTimer);
    lotTimer = setTimeout(trimiteLot, LOT_ASTEPTARE_MS);
  }

  function programeaza(li) {
    if (li.__amListaTimer) return;
    li.__amListaTimer = setTimeout(function () {
      li.__amListaTimer = null;
      if (li.__amListaVizibil && vizibil(li)) inregistreaza(li);
    }, DURATA_MS);
  }
  function anuleaza(li) {
    if (li.__amListaTimer) { clearTimeout(li.__amListaTimer); li.__amListaTimer = null; }
  }

  var observator = null;
  function observatorVizibilitate() {
    if (observator || !('IntersectionObserver' in window)) return observator;
    observator = new IntersectionObserver(function (intrari) {
      for (var i = 0; i < intrari.length; i++) {
        var e = intrari[i], li = e.target;
        li.__amListaVizibil = e.isIntersecting && e.intersectionRatio >= prag();
        if (li.__amListaVizibil) programeaza(li); else anuleaza(li);
      }
    }, { threshold: [PRAG_MOBIL, PRAG_DESKTOP] });
    return observator;
  }

  function urmaresteCardurile() {
    var g = grila();
    if (!g) return;
    var o = observatorVizibilitate();
    var carduri = g.querySelectorAll(':scope > ' + SEL_CARD);
    for (var i = 0; i < carduri.length; i++) {
      var li = carduri[i];
      if (li.__amListaUrmarit) continue;
      li.__amListaUrmarit = true;
      if (o) o.observe(li);
      else if (vizibil(li)) inregistreaza(li); // fără IO: nu pierdem tot
    }
  }

  /* Cardurile paginilor 2+ se adaugă asincron (filtrele), iar reordonarea mută
   * nodurile: urmărim mutațiile, cu o pauză scurtă, ca la recomandări. */
  var pauza = null;
  function scaneaza() {
    clearTimeout(pauza);
    pauza = setTimeout(urmaresteCardurile, 150);
  }
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(scaneaza).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'data-ts-hidden']
    });
  }
  if (document.readyState !== 'loading') { pornestePaginaCautare(); scaneaza(); }
  else document.addEventListener('DOMContentLoaded', function () { pornestePaginaCautare(); scaneaza(); });

  /* ── Clickul ───────────────────────────────────────────────────────────── */

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var link = t.closest(SEL_LINK);
    var card = (link || t).closest(SEL_CARD);
    if (!card) return;
    var g = grila();
    if (!g || card.parentElement !== g) return;   // doar grila paginii, nu recomandările
    var id = idCard(card);
    if (!id) return;
    /* Contextul pentru `am_vizualizare_atc`: pe linkul spre PDP, pe butonul de adăugare și pe
     * quickshop, nu pe Compară / culori / valori de opțiune / resigilat. Înainte de lista_click:
     * un eșec de storage nu are voie să-l împiedice. */
    if (t.closest(SEL_CONTEXT_VIZ) && !t.closest(SEL_FARA_CONTEXT_VIZ)) scrieContextVizualizare(id);
    if (!link) return;                            // butonul de adăugare nu e un „click pe produs"
    publica('lista_click', cuVizualizare(cuId({ sursa: SURSA, lista_id: LISTA_ID, lista_nume: LISTA_NUME, produs: id, pozitie: pozitia(card) }, paginaCautare)));
  }, true);

  /* ── Descrierea bogată (PDP) ───────────────────────────────────────────────
   * Linkurile către alte produse din textul scris de noi: tabelul de comparație
   * și răspunsurile din FAQ. Măsurat pe KC62 (12.09.2026): din 15 linkuri în
   * `.amy`, 9 sunt ancore interne (`#amy-poveste` — navigația secțiunilor) și
   * 6 duc către produse, în `amy-comparatie` (4) și `amy-faq` (2).
   *
   * NU se emit impresii aici, doar clickuri. Un link în text nu are „poziție"
   * comparabilă cu un card dintr-o grilă, iar o impresie pe secțiunea de
   * comparație ar măsura derularea paginii, nu interesul pentru produs. Fără
   * numitor, `select_item` rămâne un semnal de intenție, citit ca atare.
   *
   * Poziția e ordinea în DOM printre linkurile-produs UNICE ale descrierii —
   * același produs apare de două ori în tabelul de comparație (antet + card),
   * iar a doua apariție nu e o a doua opțiune. */
  if (meta.pageType === 'product') {
    /* DOUĂ constante, nu una cu virgulă. `SEL_RICH + ' a[…]'` s-ar fi parsat ca
     * `.amy` SAU `[class^="amx"] a[…]` — prima ramură potrivește CONTAINERUL, deci
     * `closest()` întorcea `div.amy` în loc de link și clickul se pierdea tăcut.
     * Prins la verificarea comportamentală pe 12.09.2026, nu din citit codul. */
    var SEL_RICH = '.amy, [class^="amx"]';                       // pentru `closest(container)`
    var SEL_RICH_LINK = '.amy a[href*="/products/"], [class^="amx"] a[href*="/products/"]';
    var LISTA_RICH = { id: 'pdp_rich_description', nume: 'Descriere produs', suprafata: 'rich' };

    document.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      var link = ev.target.closest(SEL_RICH_LINK);
      if (!link) return;
      var rich = link.closest(SEL_RICH);
      if (!rich) return;

      var href = link.getAttribute('href') || '';
      /* Doar linkuri către PROPRIUL magazin: un `href` extern care conține
       * `/products/x` (o recenzie, un site de producător) ar fi atribuit
       * produsului local `x`. Semnalat de Codex. */
      if (/^[a-z]+:\/\//i.test(href) && href.indexOf('audiomonkey.ro') === -1) return;
      var handle = href.match(/\/products\/([a-z0-9\-]+)/);
      if (!handle) return;

      /* `item_id` trebuie să fie ID-ul numeric (proxy-ul îl cere, iar GA4 leagă
       * produsele pe id). Descrierea e HTML scris de om: nu conține id-uri, doar
       * handle-uri. Îl trimitem ca handle în `produs_handle` și lăsăm pixelul să
       * decidă — el are `item_id` obligatoriu, deci fără id nu emite. Alternativa
       * (o cerere `/products/<handle>.js` la click) ar întârzia navigarea. */
      var toate = [].slice.call(rich.querySelectorAll('a[href*="/products/"]'));
      var handleuri = [], vazut = {};
      for (var i = 0; i < toate.length; i++) {
        var h = (toate[i].getAttribute('href') || '').match(/\/products\/([a-z0-9\-]+)/);
        if (h && !vazut[h[1]]) { vazut[h[1]] = true; handleuri.push(h[1]); }
      }
      var sectiune = link.closest('[id^="amy-"]');

      publica('rich_click', {
        sursa: LISTA_RICH.suprafata,
        lista_id: LISTA_RICH.id,
        lista_nume: LISTA_RICH.nume,
        produs_handle: handle[1],
        pozitie: handleuri.indexOf(handle[1]),
        sectiune: sectiune ? sectiune.id : null,
        ancora: meta.resourceId ? String(meta.resourceId) : null
      });
    }, true);
  }

  /* ── Dropdownul de căutare din header ──────────────────────────────────────
   * Suprafață SEPARATĂ de grila paginii, cu stare proprie. Nu reutilizez `vazute`,
   * `lot` sau `pozitia()`: pe `/search` același produs poate apărea și în grilă, și
   * în dropdown, iar o deduplicare comună pe id ar înghiți a doua impresie (Codex,
   * 15.09.2026). Dropdownul e în header pe TOATE paginile, deci blocul ăsta rulează
   * indiferent de `pageType`.
   *
   * Id-ul vine din `data-product-id`, pus de `typesense-search.js` chiar în
   * înregistrarea care randează rândul. NU se deduce din ordinea răspunsului
   * Typesense: ordinea din răspuns diferă de cea din DOM (măsurat 15.09 pe „kef" —
   * id-ul de la indexul 0 aparținea altui produs decât primul card afișat).
   *
   * Interogarea NU merge pe afișări/clicuri: ar fi cardinalitate nelimitată în GA4 și
   * potențial PII (oamenii caută cu numele lor, cu e-mailuri, cu numere de telefon). Pleacă
   * o singură dată, pe `audio_monkey:cautare`, iar Workerul o trece doar prin vocabular. */
  var DD_LISTA_ID = 'search_dropdown';
  var DD_LISTA_NUME = 'Sugestii căutare';
  var DD_DURATA_MS = 600;    // mai scurt decât la grilă: dropdownul se închide repede
  var DD_LOT_ASTEPTARE_MS = 300;

  var ddVazute = {};         // id → true, per RANDARE (se golește la fiecare listă nouă)
  var ddLot = [];
  var ddTimer = null;

  function ddContainer() { return document.getElementById('livesearch'); }
  function ddLista() {
    var c = ddContainer();
    if (!c || c.offsetParent === null) return null;   // dropdown închis
    return c.querySelector('ul.l4ca');
  }
  function ddCarduri(ul) {
    return [].filter.call(ul.querySelectorAll(':scope > li[data-product-id]'), function (li) {
      return li.offsetParent !== null;
    });
  }
  function ddTrimiteLot() {
    ddTimer = null;
    while (ddLot.length) {
      var bucata = ddLot.splice(0, LOT_MAX);
      publica('lista_afisat', cuId({
        sursa: 'cautare', lista_id: DD_LISTA_ID, lista_nume: DD_LISTA_NUME, produse: bucata
      }, ddIncercare));
    }
  }
  /* Flush înainte de click/navigare: altfel un client care alege imediat primul
   * rezultat ar produce un `select_item` fără `view_item_list` corespunzător, iar
   * CTR-ul ar ieși supraunitar. Cerut explicit de Codex. */
  function ddTrimiteAcum() { clearTimeout(ddTimer); if (ddLot.length) ddTrimiteLot(); }
  window.addEventListener('pagehide', ddTrimiteAcum);

  function ddInregistreaza(li, ul) {
    var id = li.getAttribute('data-product-id');
    if (!id || !/^\d+$/.test(id) || ddVazute[id]) return;
    var poz = ddCarduri(ul).indexOf(li);
    if (poz < 0) return;
    ddVazute[id] = true;
    ddLot.push({ id: id, pozitie: poz });
    clearTimeout(ddTimer);
    ddTimer = setTimeout(ddTrimiteLot, DD_LOT_ASTEPTARE_MS);
  }

  /* Impresia = rândul e VIZIBIL în dropdownul deschis timp de `DD_DURATA_MS`, nu
   * simpla lui prezență în DOM. Dropdownul e mic și complet în viewport când e
   * deschis, deci pragul care contează e TIMPUL, nu geometria: un client care
   * tastează mai departe după 200 ms n-a văzut lista intermediară. */
  var ddPandaTimer = null;
  function ddScaneaza() {
    clearTimeout(ddPandaTimer);
    ddPandaTimer = setTimeout(function () {
      var ul = ddLista();
      if (!ul) return;
      var carduri = ddCarduri(ul);
      for (var i = 0; i < carduri.length; i++) ddInregistreaza(carduri[i], ul);
    }, DD_DURATA_MS);
  }

  /* ── Încercarea din lista de sugestii (plan jurnal-cautari-ga4 §3) ──────────
   * O singură încercare DESCHISĂ. Se păstrează cât `data-am-q` (termenul LISTEI afișate, pus de
   * `typesense-search.js` în `renderRows`) rămâne același termen normalizat; reafișările nu creează
   * încercări. După angajare, orice tastare nouă deschide alta (și aceeași căutare repetată e nouă).
   * Angajarea, o dată: pauză 1,5 s / clic pe rezultat / închiderea listei după ≥ 600 ms. */
  var DD_PAUZA_MS = 1500;
  var DD_MIN_AFISARE_MS = 600;
  var ddIncercare = null;       // {id, cheie, angajata, vizibilMs, vizibilDeLa, tastatDupa}

  /* TIMPUL REAL DE AFIȘARE (review Codex 29.09, a doua rundă): se ADUNĂ doar intervalele cu lista
   * deschisă ȘI fila vizibilă. Două momente scăzute (afișare/închidere) numărau și timpul cu fila
   * ascunsă, iar o listă redeschisă cu același termen păstra închiderea veche. */
  function ddPornesteCeasul() {
    var inc = ddIncercare;
    if (inc && !inc.angajata && !inc.vizibilDeLa && document.visibilityState !== 'hidden' && ddStare()) {
      inc.vizibilDeLa = Date.now();
    }
  }
  function ddOpresteCeasul() {
    var inc = ddIncercare;
    if (inc && inc.vizibilDeLa) { inc.vizibilMs += Date.now() - inc.vizibilDeLa; inc.vizibilDeLa = 0; }
  }
  function ddTimpAfisat(inc) {
    return inc.vizibilMs + (inc.vizibilDeLa ? Date.now() - inc.vizibilDeLa : 0);
  }
  var ddPauzaTimer = null;

  function ddStare() {
    var c = ddContainer();
    if (!c || c.offsetParent === null) return null;
    var q = c.getAttribute('data-am-q');
    if (!q) return null;
    var ul = c.querySelector('ul.l4ca');
    var carduri = ul ? ddCarduri(ul) : [];
    if (carduri.length) return { q: q, stare: 'rezultate', n: Math.min(carduri.length, 250) };
    if (c.querySelector('.ts-no-results-help')) return { q: q, stare: 'zero', n: 0 };
    return null;   // în curs de încărcare / gol: nici încercare, nici angajare
  }

  function ddAngajeaza(motiv) {
    var inc = ddIncercare;
    if (!inc || inc.angajata || !permisAnalytics()) return;
    var st = ddStare();
    if (!st || cheieTermen(st.q) !== inc.cheie) return;
    inc.angajata = true;
    clearTimeout(ddPauzaTimer);
    publicaCautare(inc, 'dropdown', motiv, st.stare, st.n, termenValidat(st.q));
  }

  function ddActualizeazaIncercarea() {
    var st = ddStare();
    if (!st || !permisAnalytics()) return;
    var cheie = cheieTermen(st.q);
    if (!cheie) return;
    /* Tastare după angajare: lista afișată își păstrează id-ul până o înlocuiește cea nouă. */
    if (!ddIncercare || ddIncercare.cheie !== cheie || (ddIncercare.angajata && ddIncercare.tastatDupa)) {
      /* Termen nou: încercarea deschisă neangajată se aruncă (n-a ajuns la numitor). */
      ddIncercare = { id: idNou(), cheie: cheie, angajata: false, vizibilMs: 0, vizibilDeLa: 0 };
    }
    if (!ddIncercare.angajata) {
      ddPornesteCeasul();
      pornestePauza();
    }
  }

  /* Pauza se numără doar cât fila e VIZIBILĂ (review Codex 29.09): o filă ascunsă imediat după
   * randare nu e o căutare citită. La revenire, pauza și pragul de afișare pornesc din nou. */
  function pornestePauza() {
    clearTimeout(ddPauzaTimer);
    if (document.visibilityState === 'hidden') return;
    ddPauzaTimer = setTimeout(function () {
      if (document.visibilityState === 'hidden') return;
      if (ddStare()) ddAngajeaza('pauza');
      else ddAngajeazaLaInchidere();
    }, DD_PAUZA_MS);
  }
  document.addEventListener('visibilitychange', function () {
    var inc = ddIncercare;
    if (!inc || inc.angajata) return;
    if (document.visibilityState === 'hidden') { ddOpresteCeasul(); clearTimeout(ddPauzaTimer); return; }
    if (ddStare()) { ddPornesteCeasul(); pornestePauza(); }
  });

  /* Închiderea listei = clasele de pe <html> / formular (setDropdownOpen din typesense-search.js)
   * sau golirea containerului. Momentul se notează EXACT când se întâmplă, nu după o întârziere. */
  function noteazaInchiderea() {
    if (ddIncercare && !ddIncercare.angajata && !ddStare()) ddOpresteCeasul();
  }
  if (typeof MutationObserver !== 'undefined') {
    var ddForm = document.getElementById('search');
    var mo = new MutationObserver(noteazaInchiderea);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (ddForm) mo.observe(ddForm, { attributes: true, attributeFilter: ['class'] });
  }

  /* Lista s-a închis: `ddStare()` nu mai vede nimic, deci angajăm cu ultima stare cunoscută. */
  var ddUltimaStare = null;
  function ddAngajeazaLaInchidere() {
    var inc = ddIncercare, st = ddUltimaStare;
    if (!inc || inc.angajata || !st || cheieTermen(st.q) !== inc.cheie || !permisAnalytics()) return;
    /* Doar timpul REAL de afișare (listă deschisă + filă vizibilă) — vezi `ddTimpAfisat`. */
    ddOpresteCeasul();
    if (ddTimpAfisat(inc) < DD_MIN_AFISARE_MS) return;
    inc.angajata = true;
    clearTimeout(ddPauzaTimer);
    publicaCautare(inc, 'dropdown', 'blur', st.stare, st.n, termenValidat(st.q));
  }

  if (typeof MutationObserver !== 'undefined') {
    var ddC = ddContainer();
    if (ddC) {
      new MutationObserver(function () {
        /* Listă nouă randată (`container.innerHTML = …` înlocuiește tot `ul`-ul):
         * stare nouă. Fără asta, o a doua căutare în aceeași pagină n-ar mai
         * raporta niciun produs deja văzut la prima. Lotul vechi pleacă ÎNAINTE de
         * actualizarea încercării, deci cu id-ul listei din care a făcut parte. */
        ddTrimiteAcum();
        ddVazute = {};
        ddActualizeazaIncercarea();
        var st = ddStare();
        if (st) ddUltimaStare = st;
        else noteazaInchiderea();
        ddScaneaza();
      }).observe(ddC, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-am-q'] });
    }
  }

  /* Ascultători pe DOCUMENT, în captură: `typesense-search.js` face `stopImmediatePropagation()` pe
   * input-ul barei, deci un ascultător pus pe input nu mai primea evenimentul (review Codex 29.09).
   * Captura pe document rulează ÎNAINTEA celor de pe țintă. */
  function eBaraDeCautare(t) { return !!(t && t.id === 'search_main'); }
  document.addEventListener('input', function (ev) {
    if (eBaraDeCautare(ev.target) && ddIncercare && ddIncercare.angajata) ddIncercare.tastatDupa = true;
  }, true);
  /* Focus pierdut: lăsăm întâi clicul pe rezultat să angajeze el; închiderea s-a notat exact. */
  document.addEventListener('focusout', function (ev) {
    if (!eBaraDeCautare(ev.target)) return;
    noteazaInchiderea();
    setTimeout(function () {
      noteazaInchiderea();
      if (!ddStare()) ddAngajeazaLaInchidere();
    }, 250);
  }, true);

  /* Trimiterea formularului (Enter, butonul, tastatura mobilă): NU angajează aici. Predă paginii
   * /search încercarea curentă (cu starea ei de angajare) dacă termenul trimis e același, altfel una
   * nouă. Enter pe brand/categorie merge direct la o colecție din `typesense-search.js` (fără
   * submit), deci nu lasă predare. */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.querySelector || !f.querySelector('#search_main')) return;
    var inp = f.querySelector('#search_main');
    var cheie = cheieTermen(inp && inp.value);
    if (!cheie) return;
    var inc = (ddIncercare && ddIncercare.cheie === cheie && !(ddIncercare.angajata && ddIncercare.tastatDupa))
      ? ddIncercare : { id: idNou(), angajata: false };
    ddTrimiteAcum();              // afișările în așteptare pleacă ÎNAINTE, cu id-ul listei lor
    scriePredare({ id: inc.id, cheie: cheie, angajata: inc.angajata });
    clearTimeout(ddPauzaTimer);   // pagina angajează, nu dropdown-ul
    if (ddIncercare === inc) ddIncercare = null;
  }, true);

  document.addEventListener('click', function (ev) {
    if (!ev.target || !ev.target.closest) return;
    var link = ev.target.closest(SEL_LINK);
    if (!link) return;
    var li = link.closest('li[data-product-id]');
    if (!li) return;
    var ul = li.parentElement;
    if (!ul || !ul.classList.contains('l4ca')) return;          // doar dropdownul
    var c = ddContainer();
    if (!c || !c.contains(li)) return;                          // și doar al nostru
    var id = li.getAttribute('data-product-id');
    if (!id || !/^\d+$/.test(id)) return;
    ddTrimiteAcum();                                            // impresia înaintea clickului
    ddAngajeaza('clic');                                        // încercarea înaintea clicului ei
    publica('lista_click', cuId({
      sursa: 'cautare', lista_id: DD_LISTA_ID, lista_nume: DD_LISTA_NUME,
      produs: id, pozitie: ddCarduri(ul).indexOf(li)
    }, ddIncercare));
  }, true);
})();
